function authInterceptor($rootScope, $q, $injector) {

  'ngInject';

  let state;

  return {

    // intercept HTTP 401s
    responseError: (response) => {
      // manual 'inject' due to circular dependency hell
      const AuthService = $injector.get('AuthService');

      if (response.status === 401) {
        // remove any stale token
        AuthService.logout();
        // redirect to login
        (state || (state = $injector.get('$state'))).go('login');
      }

      return $q.reject(response);
    },
  };

}

export default authInterceptor;



// WEBPACK FOOTER //
// ./src/modules/auth/auth.interceptor.js